import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import DocumentTypeForm from './DocumentTypeForm';

const DocumentTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const DocumentTypeEdit = (props: any) => {
  return (
    <Edit actions={<DocumentTypeActions {...props} />} {...props}>
      <DocumentTypeForm />
    </Edit>
  );
};

export default DocumentTypeEdit;
